import type { UserAccountDto } from '@dto/UserAccount.dto';
import type { FC, ReactNode } from 'react';
import { createContext, useContext } from 'react';

type ContextValue = UserAccountDto | void;

export const UserContext = createContext<ContextValue>(undefined);

export const useUserContext = () => useContext(UserContext);

interface UserProviderProps {
  account: ContextValue;
  children?: ReactNode;
}

export const UserProvider: FC<UserProviderProps> = ({ children, account }) => (
  <UserContext.Provider value={account}>{children}</UserContext.Provider>
);
